import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const styles = makeStyles(theme => {
  return {
    box: {
      position: "absolute" as "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: 600
    },
    footer: {
      background: "#FFF",
      padding: "8px",
      borderRadius: "8px",
      position: "absolute" as "absolute",
      top: "90%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      overflowX: "auto"
    },
    imageFooter: {
      height: "75px",
      width: "98px",
      borderRadius: "8px",
      marginRight: "4px",
      cursor: "pointer"
    },
    leftButton: {
      background: "#FFF",
      position: "absolute" as "absolute",
      top: "50%",
      left: "5%",
      transform: "translate(-50%, -50%)"
    },
    rightButton: {
      background: "#FFF",
      position: "absolute" as "absolute",
      top: "50%",
      left: "95%",
      transform: "translate(-50%, -50%)"
    }
  };
});

export default styles;
